import { IValidationLocalizer, ValidateErrors, ValidatingDataType } from "./ValidityInterfaces";
/**
     * Pomocná třída pro zpracovávání validačních chyb a jejich lokalizaci
     * @includeToDoc
     */
export class ValidityStateHelper {
    /**
     * Zpracuje validační chyby a vytvoří lokalizované validační hlášky a objekt stavu validity pro html input komponenty https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
     * @param validateErrors nalezené validační chyby
     * @param dataType datový typ, pro který se provádí validace
     */
    public static createValidateState(validateErrors: ValidateErrors, dataType: ValidatingDataType): { validationMessage: string; validity: ValidityState } {
        const validity = { badInput: false, customError: false, patternMismatch: false, rangeOverflow: false, rangeUnderflow: false, stepMismatch: false, tooLong: false, typeMismatch: false, valueMissing: false, valid: false };

        if (!validateErrors) {
            validity.valid = true;
            return { validationMessage: "", validity: validity as ValidityState };
        } else {
            let recognizedError = false;
            if ((validateErrors & ValidateErrors.badInput) > 0)
                validity.badInput = recognizedError = true;
            if ((validateErrors & ValidateErrors.rangeOverflow) > 0)
                validity.rangeOverflow = recognizedError = true;
            if ((validateErrors & ValidateErrors.rangeUnderflow) > 0)
                validity.rangeUnderflow = recognizedError = true;

            if (!recognizedError)
                validity.badInput = true;

            return { validationMessage: ValidityStateHelper.localizeValidateError(validateErrors, dataType), validity: validity as ValidityState };
        }
    }

    /**
     * Zlokalizuje validační chyby
     * @param validateErrors nalezené validační chyby
     * @param dataType datový typ, pro který se provádí validace
     */
    public static localizeValidateError(validateErrors: ValidateErrors, dataType: ValidatingDataType): string {
        switch (validateErrors) {
            case ValidateErrors.valid:
                return "";
            case ValidateErrors.badInput:
                switch (dataType) {
                    case ValidatingDataType.float:
                        return ValidityStateHelper.validityLocalizer.getLocalization("VAL-100");
                    case ValidatingDataType.integer:
                        return ValidityStateHelper.validityLocalizer.getLocalization("VAL-101");
                    case ValidatingDataType.date:
                        return ValidityStateHelper.validityLocalizer.getLocalization("VAL-102");
                    case ValidatingDataType.time:
                        return ValidityStateHelper.validityLocalizer.getLocalization("VAL-103");
                    case ValidatingDataType.dateTime:
                        return ValidityStateHelper.validityLocalizer.getLocalization("VAL-104");
                }
                break;
            case ValidateErrors.rangeOverflow | ValidateErrors.rangeUnderflow:
                return ValidityStateHelper.validityLocalizer.getLocalization("VAL-202");
            case ValidateErrors.rangeUnderflow:
                return ValidityStateHelper.validityLocalizer.getLocalization("VAL-200");
            case ValidateErrors.rangeOverflow:
                return ValidityStateHelper.validityLocalizer.getLocalization("VAL-201");
        }
        return ValidityStateHelper.validityLocalizer.getLocalization("VAL-0");
    }

    /**
     * Použitý lokalizátor validačních hlášek, je možné zaregistrovat vlastní
     */
    public static validityLocalizer: IValidationLocalizer;
}
